import React from 'react';
import { ReactComponent as ClaudeCodeIcon } from '@lobehub/icons-static-svg/icons/claudecode-color.svg';
import codexUrl from '@lobehub/icons-static-svg/icons/codex-color.svg';
import { ReactComponent as CursorIcon } from '@lobehub/icons-static-svg/icons/cursor.svg';
import { ReactComponent as GrokIcon } from '@lobehub/icons-static-svg/icons/grok.svg';
import geminiUrl from '@lobehub/icons-static-svg/icons/gemini-color.svg';

/**
 * ONE place for agent brand icons (moved out of terminal/, 01.10.2026): the
 * Terminal pane header and the board comments an agent wrote over MCP (card
 * 13eb6ec0) both use it, so an agent gets its icon in one place only.
 *
 * Brand icons of the built-in agent profiles, from `@lobehub/icons-static-svg`
 * (MIT). Claude Code and Codex are the colour files; Cursor and Grok are mono
 * (`fill="currentColor"`), so they take the text colour around them — light
 * on the dark pane header, dark in a light menu. Custom profiles have no
 * brand and keep their lettermark tile.
 */
/**
 * Codex's file defines a gradient under a FIXED id (`lobe-icons-codex-_R_0_`)
 * and svgr inlines ids verbatim, so every inlined copy would share it — and
 * Chromium drops the gradient for all copies once the first one is hidden
 * (review R3). As an <img> the SVG is its own document, so its ids cannot
 * collide. It is a colour icon (no currentColor), so nothing is lost; the
 * mono icons stay inline for currentColor.
 */
function CodexIcon({ width, height }) {
  return <img src={codexUrl} alt="" width={width} height={height} draggable={false} style={{ display: 'block' }} />;
}

// Gemini's colour file has gradient ids too: an <img> for the same reason.
function GeminiIcon({ width, height }) {
  return <img src={geminiUrl} alt="" width={width} height={height} draggable={false} style={{ display: 'block' }} />;
}

const BRAND_ICONS = {
  claude: ClaudeCodeIcon,
  codex: CodexIcon,
  cursor: CursorIcon,
  grok: GrokIcon,
  gemini: GeminiIcon,
};

/** The brand icon component for a built-in profile id, or null. */
export function agentIconFor(profileId) {
  return (profileId && Object.prototype.hasOwnProperty.call(BRAND_ICONS, profileId) && BRAND_ICONS[profileId]) || null;
}
